import { FloatingBarUserController } from './floating-bar-user.controller.js'

function floatingBarUser () {
  return {
    restrict: 'E',
    scope: {
      selectedTemplates: '=',
      selectedCollections: '=',
      onUnselectAllAssets: '&',
      location: '<',
      onDownload: '<'
    },
    templateUrl: '/arts/directives/floating-bar-user/floating-bar-user-directive.html?$$REVISION$$',
    controller: FloatingBarUserController
  }
}

export { floatingBarUser }
